// @flow
import Dotdotdot from 'react-dotdotdot';
import { getItemUrl } from '../../utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import { safelyRender } from '../../utils/safelyRender';
import styles from './TitleRow.module.scss';

type Props = {
    hideLotNumbers: boolean,
    isSEOExcluded: boolean,
    itemId: number,
    lotNumber: string,
    openOnBlank: boolean,
    title: string,
};

const TitleRow = (props: Props) => {
    const { hideLotNumbers, itemId, isSEOExcluded, lotNumber, openOnBlank, title } = props;

    const safeTitle = safelyRender(title, 'span');
    const itemUrl = getItemUrl(itemId, title);
    const lotNumberDisplay = lotNumber ? (
        <span className={styles['lot-number']}>
            {' '}
            {lotNumber}
            :&nbsp;{' '}
        </span>
    ) : (
        <span className={styles['lot-number']}>
            {' '}
            &nbsp;
            {'0000'}
        </span>
    );

    const targetProps = openOnBlank
        ? { rel: isSEOExcluded ? 'nofollow' : '', route: false, target: '_blank' }
        : { rel: isSEOExcluded ? 'nofollow' : '', route: true };

    return (
        <div className={styles['item-title-container']}>
            {title ? (
                <Link className={styles['item-title']} {...targetProps} to={itemUrl} primary>
                    <Dotdotdot clamp={2}>
                        {!hideLotNumbers && lotNumberDisplay}
                        {safeTitle}
                    </Dotdotdot>
                </Link>
            ) : (
                <span className={styles['item-title']}>Lorem ipsum dolor sit amet, consectetur adipiscing elit</span>
            )}
        </div>
    );
};

export default React.memo<Props>(TitleRow);
